import dayjs from 'dayjs'
import {startOfDay} from 'date-fns'
import {Input} from 'antd'
import {
  Form,
  FormItem,
  Button,
  Select,
  InputAmount,
  DatePicker,
  useForm,
  // useWatch,
} from 'common/components'
import {useInputFocus} from 'common/hooks'
// import {
//   useCreateForecastItem,
//   useUpdateForecastItem,
//   useUpdateForecast,
// } from 'common/api'
import {
  // fixNumber,
  // formatDate,
  // formatMoney,
  // isItemDrawdown,
  // changeForecastDrawdownItem,
  // totalNumberFromArray,
  // getNextEstimatedDrawdowns,
  // getNewForecastItemFormValues,
  // getNewSortedForecastByChangeItem,
  // getDrawdownsSurplus,
} from 'common/helpers'
import {FIELD_RULES} from 'common/constants'
import {ForecastFormItem, SetNewForecast} from 'common/types'
import {useCreateJournal, useUpdateJournal} from '../api.journal'

const {TextArea}=Input
interface JournalItemFormProps {
  projectUuid?: string
  requestUuid?: string
  item?: any
  minDate?: Date
  forecastItem?: ForecastFormItem
  itemDate?: Date
  loanValue?: number
  forecast?: ForecastFormItem[]
  setNewForecast?: SetNewForecast
  request?: any
  onClose: () => void
}

export default function JournalItemForm({
  // projectUuid,
  minDate,
  item,
  // requestUuid,
  // forecastItem,
  // itemDate,
  // loanValue,
  // forecast,
  // setNewForecast,
  request,
  onClose,
}: JournalItemFormProps) {
  const {mutate: createJournal} = useCreateJournal(onClose)
  const {mutate: updateJournal} = useUpdateJournal(item?.uuid, onClose)
  
  const [form] = useForm()
  // const typeValue = useWatch('type', form)
  // const dateValue = useWatch('date', form)
  // const amountValue = useWatch('amount', form)
  const inputRef = useInputFocus()

  const today = startOfDay(new Date())
  // const hasForecast = Boolean(projectUuid)
  // const isItemEdit = Boolean(hasForecast && forecastItem)
  // const isDrawdown = isItemDrawdown({type: typeValue})
  // const isForecastDrawdown = hasForecast && isDrawdown
  // const drawdowns = forecast.filter((item) => isItemDrawdown(item))
  // const surplus = getDrawdownsSurplus(
  //   drawdowns,
  //   dateValue,
  //   loanValue,
  //   amountValue,
  //   forecastItem?.uuid
  // )

  const handleFinish = (values: any) => {
    const payload = {
      ...values,
      date: dayjs(values.date).format("YYYY-MM-DD"),
      variationRequestUuid: request.uuid
    }
    if (!item) {
      createJournal(payload)
    } else {
      updateJournal(payload)
    }
    return

    // if (!hasForecast) {
      // const newValues = getNewForecastItemFormValues(values, forecastItem)
      // setNewForecast((state) => {
      //   const sortedNewForecast = getNewSortedForecastByChangeItem(
      //     newValues,
      //     state
      //   )
      //   if (isDrawdown) {
      //     return changeForecastDrawdownItem({
      //       loanValue,
      //       forecast: sortedNewForecast,
      //       drawdown: newValues,
      //     })
      //   }
      //   return sortedNewForecast
      // })
      // return onClose()
    // }
    // handleSingleItemChange(values)
  }

  // const handleSingleItemChange = (values: any) => {
    // const date = formatDate(values.date, 'server')
    // console.log(date)
    // forecastItem
    //   ? updateForecastItem({date, amount: values.amount})
    //   : createForecastItem({
    //       ...values,
    //       date,
    //       loanRequest: requestUuid,
    //       project: projectUuid,
    //     })
  // }

  const handleFieldsChange = (values: any) => {
    if (!('type' in values)) return
    form.resetFields(['date', 'amount'])
  }

  // const disabledDates = isDrawdown
    // ? (forecastItem
    //     ? forecast.filter((item) => item.uuid !== forecastItem.uuid)
    //     : forecast
    //   ).map((item) => item.date)
    // : undefined

  const dateFieldRules = FIELD_RULES
    // isDrawdown
    // ? [
    //     ...FIELD_RULES,
    //     () => ({
    //       validator(_: any, value: Date) {
    //         if (value >= today) {
    //           return Promise.resolve()
    //         }
    //         return Promise.reject(
    //           value ? `The date must be a date after now` : undefined
    //         )
    //       },
    //     }),
    //   ]
    // : FIELD_RULES

  const amountFieldRules = FIELD_RULES
    // isForecastDrawdown && surplus < 0
    //   ? [
    //       ...FIELD_RULES,
    //       () => ({
    //         validator(_: any, value: number) {
    //           if (
    //             surplus +
    //               totalNumberFromArray(
    //                 getNextEstimatedDrawdowns(
    //                   drawdowns,
    //                   dateValue,
    //                   forecastItem?.uuid
    //                 ),
    //                 'amount'
    //               ) >=
    //             0
    //           ) {
    //             return Promise.resolve()
    //           }
    //           return Promise.reject(
    //             value
    //               ? `Estimation is higher than the loan ${formatMoney(
    //                   loanValue
    //                 )}`
    //               : undefined
    //           )
    //         },
    //       }),
    //     ]
    //   : FIELD_RULES

  const defaultPickerValue = today
    // forecastItem || itemDate ? undefined : minDate > today ? minDate : today

  // const isInitialDrawdown = Boolean(
  //   forecastItem &&
  //     forecast.findIndex((item) => item.uuid === forecastItem.uuid) === 0
  // )

  // console.log(item)
  const initialValues = !item ? undefined : {
    type: item.reference,
    date: dayjs(item.date).toDate(),
    amount: item.credit ?? item.debit,
    statementNote: item.note || '',
  }
  return (
    <>
      <Form
        form={form}
        initialValues={initialValues}
        validateTrigger="onChange"
        onValuesChange={handleFieldsChange}
        onFinish={handleFinish}
      >
        <FormItem name="type" label="Type" rules={FIELD_RULES}>
          <Select
            options={typeOptions}
            readOnly={false} // {isItemEdit || isInitialDrawdown}
          />
        </FormItem>
        <FormItem name="date" label="Date" rules={dateFieldRules}>
          <DatePicker
            defaultPickerValue={defaultPickerValue}
            disabledDate={(d:Date) => d < minDate}
            // minDate={minDate}
            // disabledDates={disabledDates}
            // disabled={isInitialDrawdown}
          />
        </FormItem>
        <FormItem name="amount" label="Amount, $ nzd" rules={amountFieldRules}>
          <InputAmount ref={inputRef} min={0} />
        </FormItem>
        <FormItem name="statementNote" label="Statement note" rules={FIELD_RULES}>
          <TextArea rows={2} />
        </FormItem>
        <Button
          block
          htmlType="submit"
          loading={
            false
            // isCreateMutating || isUpdateMutating || isUpdateForecastMutating
          }
        >
          {!item ? 'Add':'Save'} journal
        </Button>
      </Form>
    </>
  )
}

const typeOptions = [
  {value: 'Journal Credit', label: 'Journal Credit'},
  {value: 'Journal Debit',  label: 'Journal Debit'},
]
